module.exports = __webpack_public_path__ + "img/northridge-logo.a4458025.png";